//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import classname from 'classname';

import { BootstrapIcon } from '../BootstrapIcon';
import * as choiceApi from '../../api/choice';

import './FAQ.scss';

export function FAQ({
    faq,
}) {

    const [ collapsed, setCollapsed ] = useState(true);

    if (!faq) {
        return null;
    }

    const icon = collapsed ? "caret-right" : "caret-down";


    return (
        <div className="faq-item">
            <div className="question" onClick={() => setCollapsed(!collapsed)} >
                <BootstrapIcon icon={icon} />
                <span> {faq.question}</span> 
            </div>
            <div className={classname('answer', { 'collapsed': collapsed })}>
                <span dangerouslySetInnerHTML={{ __html: faq.answer }} />
                {/* {faq.answer} */}
            </div>
        </div>
    );
}


export function FAQList(props) {
    const [faq, setFaq] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const list = await choiceApi.getFaq();
            if (list) {
                setFaq(list);
            }
        }

        fetchData();

    }, [])

    const displayFaq = faq.map((q) =>
        <FAQ key={`faq-${q.id}`} faq={q} />
    );


    return (
        <Container className="faq">
            <h1>Frequenty Asked Questions</h1>
            {displayFaq}
        </Container>
    );
}
